// Stati UI riutilizzati: empty / loading / full-screen.
import { useTranslation } from "react-i18next";
import { AuthShell } from "./shell/AuthShell";

export function EmptyState({ text }: { text: string }) {
  return (
    <div className="rounded-xl border border-dashed bg-muted/30 px-4 py-8 text-center text-sm text-muted-foreground">
      {text}
    </div>
  );
}

export function SectionLoading() {
  const { t } = useTranslation("common");
  return (
    <div className="rounded-2xl border bg-card px-6 py-12 text-center text-sm text-muted-foreground animate-pulse">
      {t("common.loadingData")}
    </div>
  );
}

export function FullScreenState({ title, description }: { title: string; description: string }) {
  return (
    <AuthShell>
      <h1 className="text-[26px] font-bold leading-tight">{title}</h1>
      <p className="mt-2 text-muted-foreground">{description}</p>
    </AuthShell>
  );
}
